export default __webpack_public_path__ + "static/media/crypto-expo-dubai.0c0210bb.png";